import React, { Component } from 'react'
import styled from 'styled-components'

import { Grid, Row } from 'react-flexbox-grid'
import { ShadowBox } from '@ubiwherenpm/adene-ui-components'

import ChangeIcon from './images/change.component.svg'
import EditIcon from '../Svg/ic-editar.svg'
import { isEnterprise } from 'config'
import { generateMediaUrl, unitCurrency, pricesCurrency } from 'utils'

export const Eletricity = ({ electricityConsumption, prices, timeCycle, entity, className }) => {
  return (
    <EletricityRow>
      <EletricityEntityCol className={className}>
        <ResultLabel el>Eletricidade</ResultLabel>
        {entity &&
          <Entity src={entity.logo} alt={entity.name} />
        }
      </EletricityEntityCol>
      <NumberysCol>
        {electricityConsumption &&
        <Numberyx style={{ marginBottom: 12 }}>
          <NumberyLabel>Consumo</NumberyLabel>
          <Price>{Number(electricityConsumption).toFixed(0) || '---'} <Unit>kWh/ano</Unit></Price>
        </Numberyx>
        }
        <Numberyx>
          <NumberyLabel>Termo Potência</NumberyLabel> 
          <Price>{pricesCurrency(prices.electricity.termo_fixo) || '---'} <Unit>€/dia</Unit></Price>
        </Numberyx>
        <Numberyx style={{ marginTop: 12 }}>
          <NumberyLabel>Energia</NumberyLabel> 
          {timeCycle === 's' && 
            <Price>{`${pricesCurrency(prices.electricity.cheia) || '---'}`} <Unit>€/kWh</Unit></Price>
          } 
        </Numberyx>
        {timeCycle === 'b' &&
          <NumberyxSmall>
            <NumberyLabelSmall>Fora do Vazio</NumberyLabelSmall> 
            <Price>{pricesCurrency(prices.electricity.cheia) || '---'} <Unit>€/kWh</Unit></Price>
          </NumberyxSmall>
        }
        {timeCycle !== 's' &&
          <NumberyxSmall>
            <NumberyLabelSmall>Vazio</NumberyLabelSmall> 
            <Price>{pricesCurrency(prices.electricity.vazio) || '---'} <Unit>€/kWh</Unit></Price>
          </NumberyxSmall>
        }
        {timeCycle !== 'b' && timeCycle !== 's' &&
            <NumberyxSmall>
              <NumberyLabelSmall>Pontas</NumberyLabelSmall> 
              <Price>{pricesCurrency(prices.electricity.ponta) || '---'} <Unit>€/kWh</Unit></Price>
            </NumberyxSmall>
          }
          {timeCycle !== 'b' && timeCycle !== 's' &&
            <NumberyxSmall>
              <NumberyLabelSmall>Cheias</NumberyLabelSmall> 
              <Price>{pricesCurrency(prices.electricity.cheia) || '---'} <Unit>€/kWh</Unit></Price>
            </NumberyxSmall>
        }
      </NumberysCol>
    </EletricityRow>
  )
}

export const Gas = ({ gasConsumption, prices, entity, className }) => {
  return (
    <GasRow>
      <GasEntityCol className={className}>
        <ResultLabel ga>Gás Natural</ResultLabel>
        {entity &&
          <Entity src={entity.logo} alt={entity.name} />
        }
      </GasEntityCol>
      <NumberysCol>
        {gasConsumption &&
          <Numberyx style={{ marginBottom: 12 }}>
            <NumberyLabel>Consumo</NumberyLabel>
            <Price>{Number(gasConsumption).toFixed(0) || '---'} <Unit>kWh/ano</Unit></Price>
          </Numberyx>
          }
          <Numberyx>
            <NumberyLabel>Termo Fixo</NumberyLabel>
            <Price>{pricesCurrency(prices.gas.termo_fixo) || '---'} <Unit>€/dia</Unit></Price>
        </Numberyx>
        <Numberyx style={{ marginTop: 12 }}>
            <NumberyLabel>Energia</NumberyLabel>
            <Price>{pricesCurrency(prices.gas.termo_energia) || '---'} <Unit>€/kWh</Unit></Price>
          </Numberyx>
      </NumberysCol>
    </GasRow>
  )
}

export default class TopResult extends Component {
  render () {
    let {
      annualBilling,
      electricityPriceList,
      gasPriceList,
      simulationCode,
      hasSimulation,
      error,
      onClickToSave,
      onClickToChangePrices,
      router
    } = this.props

    let entity

    if (electricityPriceList) {
      entity = electricityPriceList.entity

      if (entity) {
        entity.logo = generateMediaUrl(entity.hi_res_logo)
      }
    }

    if (gasPriceList) {
      entity = gasPriceList.entity

      if (entity) {
        entity.logo = generateMediaUrl(entity.hi_res_logo)
      }
    }

    return (
      <Wrapper noSimulation={!hasSimulation}>
        <Container fluid>
          <FiltersList noSimulation={!hasSimulation}>
            <Scrollable noSimulation={!hasSimulation}>
            <Flexed>
              <GreyCol noSimulation={!hasSimulation}>
                <Simulation>
                  <SimulationNumber noSimulation={!hasSimulation}>
                    <ChangeData onClick={() => router.push('/')}> <BackButton>&#60;</BackButton> Alterar dados da simulação</ChangeData>
                    <SimulationLabel>simulação</SimulationLabel>
                    <SimulationNumbery>#{simulationCode}</SimulationNumbery>
                  </SimulationNumber>
                  {hasSimulation &&
                    <SimulationTitle>
                      <Title>O seu tarifário atual</Title>
                    </SimulationTitle>
                  }
                </Simulation>
                {hasSimulation &&
                  <FaturaCol>
                    <TitleLabel>Fatura de Energia *</TitleLabel>
                    <Numbery>{annualBilling && unitCurrency(annualBilling)} €/ano</Numbery>
                    <SmallNumber>{annualBilling && unitCurrency(annualBilling / 12)} €/mês</SmallNumber>
                  </FaturaCol>
                }

                {!hasSimulation &&
                <NoSimTitle grey dangerouslySetInnerHTML={{__html: error}} />}
              </GreyCol>

                {electricityPriceList &&
                <FlexedElectricity {...this.props} entity={electricityPriceList.entity} />}
                {gasPriceList &&
                <FlexedGas {...this.props} entity={gasPriceList.entity} />}
              </Flexed>

            </Scrollable>
            <ChangeCol noSimulation={!hasSimulation}>
              {!isEnterprise &&
                <ChangeButton onClick={() => onClickToChangePrices()}>
                  <img style={{ marginRight: 12 }} src={EditIcon} alt={`Ajustar Preços`}/>
                  <ButtonLabel >Ajustar Preços</ButtonLabel>
                </ChangeButton>
              }
              <ChangeButton onClick={() => onClickToSave && onClickToSave()}>
                <ChangeIcon />
                <ButtonLabel >Guardar Perfil de Simulação</ButtonLabel>
              </ChangeButton>
            </ChangeCol>
          </FiltersList>
        </Container>
      </Wrapper>
    )
  }
}

const FlexedElectricity = styled(Eletricity)`
  flex: 0.25 !important;
`

const ChangeData = styled.span`
  color: #006736;	
  font-size: 14px;	
  font-weight: bold;	
  line-height: 14px;
  cursor: pointer;
  position: absolute;
  top: -30px;
  margin-left: 20px;
  display: block;
  width: 127%;
`

const BackButton = styled.span`
  font-size: 18px;
`

const FlexedGas = styled(Gas)`
  flex: 0.25 !important;
`

const Flexed = styled.div`
  display: flex;
  flex-direction: row;

  @media(max-width: 980px) {
    flex-direction: column !important;
  }
`

const Wrapper = styled(ShadowBox)`
  height: 180px;
  width: 100%;
  width: 1136px;
  margin: 0 auto;
  position: relative;
  top: -100px;
  display: flex;
  margin-bottom: -100px;

  ${({ noSimulation }) => noSimulation && `
    height: 300px;
  `}

  @media(max-width: 1200px) {
    width: 100%;
    flex-direction: column !important;
    height: initial;
  }
`

const FiltersList = styled(Row)`
  margin: 0 !important;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  height: 100%;

  @media(max-width: 1200px) {
    display: flex;
    flex-direction: column !important;
  }

  ${({ noSimulation }) => noSimulation && `
    @media(max-width: 1200px) {
      display: flex;
      flex-direction: column;
    }
  `}
`

const Container = styled(Grid)`
  padding-left: 0!important;
  padding-right: 0!important;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;

  @media(max-width: 1200px) {
    margin-left: initial !important;
    margin-right: initial !important;
  }
`

const Scrollable = styled.div`
  display: flex;
  flex: 1;

  @media(max-width: 1200px) {
    max-width: 100%;
    flex-direction: column;
  }
`

const GreyCol = styled.div`
  background-color: #676767;
  flex: 0.2;
  position: relative;

  @media (max-width: 1200px) {
    min-width: 150px;
  }

  ${({ noSimulation }) => noSimulation && `
    background: #fff;
    flex: 2;
  `}
`

const EletricityRow = styled.div`
  display: flex;
  flex-direction: row;
  border-right: 1px solid #F9F9F9;

  @media (max-width: 1200px) {
    margin-right: 0;
    min-width: 165px;
    min-height: 170px;
  }

  @media (max-width: 1000px) {
    border-right: none;
  }
  
  @media (max-width: 440px) {
    flex-direction: column;
  }
`

const GasRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5%;

  @media (max-width: 1200px) {
    margin-right: 0;
    min-width: 165px;
    min-height: 170px;
  }

  @media (max-width: 440px) {
    flex-direction: column;
  }
`

const SimulationNumber = styled.div`
  height: 56px;	
  width: 150px;
  border: 1px solid #EFEFEF;	
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Simulation = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: -56px;
`

const SimulationLabel = styled.span`
  display: block;
  font-size: 12px;
  color: #676767;
  font-weight: 600;
  line-height: 10px;
  text-align: center;
`

const SimulationNumbery = styled.span`
  color: #93C13E;
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
`

const Title = styled.span`
  height: 24px;	
  width: 165px;	
  color: #676767;	
  font-family: Nunito;	
  font-size: 18px;	
  font-weight: bold;	
  line-height: 24px;
  text-align: center;
`

const SimulationTitle = styled.div`
  border: 1px solid #EFEFEF;	
  background-color: rgba(255,255,255,0.6);
  width: 197px;
  height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media(max-width: 426px) {
    width: 172px;
  }

  @media (max-width: 340px) {
    display: none;
  }
`

const NoSimTitle = styled.div`
  color: #010101;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  position: relative;
  top: -8px;
  height: 90%;
  display: flex;
  align-items: center;
  padding: 32px;

  @media(max-width: 780px) {
    font-size: 16px;
  }
`

export const FaturaCol = styled.div`
  flex: 0.30;
  position: relative;
  display: flex;
  padding: 15% 20px 0 20px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 150px;

  @media(max-width: 1200px) {
    max-width: none;
    justify-content: initial;
    align-items: initial;
    padding: 0;
  }
`

export const Numbery = styled.span`
  color: white;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  margin: 10px 0;
  margin-top: 0;
`

const SmallNumber = styled(Numbery)`
  font-size: 13px;
`

const Unit = styled.span`
font-weight: normal;
`

const Price = styled.span``

export const Label = styled.span`
  color: #9C9C9C;
  font-family: Nunito;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
`

const ChangeCol = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-shadow: inset 1px 0 0 0 #EFEFEF;
  cursor: pointer;
  margin-left: auto;
  max-width: 150px;

  @media(max-width: 1200px) {
    flex-direction: row;
    max-width: none;
    margin-left: initial;
    align-items: initial;
  }

  ${({ noSimulation }) => noSimulation && `
    @media(max-width: 1200px) {
      flex-direction: row;
      max-width: none;
      margin-left: initial;
      align-items: initial;
    }
  `}
`

const ChangeButton = styled.button`
  border:0;
  background: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #EFEFEF;
  border: 1px solid #DEDEDE;
  flex: 1;
  width: 100%;
  padding: 0 15px;
  box-shadow: inset 1px -1px 0 0 #EFEFEF;

  &:last-child {
    box-shadow: none;
  }

  @media(max-width: 1200px) {
    padding: 16px;
  }
`

const ButtonLabel = styled.span`
  display: block;
  text-align: center;
  font-weight: bold;
  color: #3E3E3E;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  text-align: left;
  margin-left: 10px;
  flex: 1;

  @media (max-width: 340px) {
    font-size: 12px;
  }
`

const Numberyx = styled.span`
  color: #676767;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 2px 0;
`

const NumberyxSmall = styled.span`
  font-size: 12px;	
  line-height: 12px;
  color: #676767;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 2px 0;
`

const NumberyLabel = styled.span`
color: #676767;
font-size: 14px;
font-weight: 100;


margin-right: 10px;
display: inline-block;
vertical-align: middle;
`

const NumberyLabelSmall = styled.span`
color: #676767;
font-size: 12px;
font-weight: 100;


margin-right: 10px;
display: inline-block;
vertical-align: middle;
`

const NumberysCol = styled.div`
  flex: 0.25;
  text-align: left;
  margin-left: 35px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 20px;
  min-width: 190px;
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 35px;
    min-width: 290px;
    margin-left: 20px;
  }
  
  @media (max-width: 1100px) {
    min-width: 220px !important;
  }
`

const GasEntityCol = styled.div`
  flex: 0.25;
  text-align: left;
  padding: 0 0 0 15px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 120px;
  margin-top: 20px;
  align-items: center;

  @media (max-width: 1100px) {
    text-align: center;
  }
`

const EletricityEntityCol = styled.div`
  flex: 0.25;
  text-align: left;
  margin-left: 15px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 95px;
  margin-top: 20px;
  align-items: center;

  @media (max-width: 1100px) {
    min-width: 75px !important;
  }
` 

const Entity = styled.img`
  max-height: 50%;
  max-width: 50%;
  display: block;

  @media (max-width: 440px) {
    max-width: 30% !important;
  }
`

const TitleLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin: 20px 0;
  color: #ccc;
  white-space: nowrap;
`

const ResultLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin: 10px 0;
  margin-top: 10px;
  color: ${({ el }) => el ? `#FF8E2A` : `#00BDED`};

  span {
    color: #ccc;
  }
`



// WEBPACK FOOTER //
// ./src/components/TopResult/index.js